import { render, staticRenderFns } from "./ConvergeProvider.vue?vue&type=template&id=7c796495&"
import script from "./ConvergeProvider.vue?vue&type=script&lang=ts&"
export * from "./ConvergeProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports